<template>
  <div
    ref="excel-dom"
    class="excel-table"
    @scroll="scrollEvent($event)"
    v-if="excelGridDom.length"
  >
    <table class="formdata">
      <tr>
        <th></th>
        <th
          width="100"
          scope="col"
          v-for="(value,key) in excelGridDom[0]"
          :key="key"
        >{{key}}</th>
      </tr>
      <tr
        v-for="(item,index) in excelGridDom"
        :key="index"
      >
        <th
          scope="row"
          class="rowstyle"
        >{{index+1}}</th>
        <td
          v-for="keys in item"
          :key="keys"
        >{{keys}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import XLSX from 'xlsx' // 预览
// import canvasDatagrid from 'canvas-datagrid'

export default {
  name: 'ExcelView',
  props: {
    datas: null
  },
  data () {
    return {
      excelGridData: [],
      excelGridDom: [],
      workbook: null,
      sheets: [],
      sheetNames: [],
      sheetActive: '',
      num: 40
    }
  },
  methods: {

    onTabWorkbook (index) {
      var datas = this.sheets[this.sheetNames[index]] // 这里读取第index张sheet
      var csv = XLSX.utils.sheet_to_csv(datas)
      this.excelGridData = []
      // this.$refs['excel-dom'].innerHTML = ''
      var rows = csv.split('\n')
      rows.pop() // 最后一行（空数组）没用的
      rows.forEach((row, idx) => {
        var columns = row.split(',')
        const obj = {}
        this.excelGridData.push(obj)
        for (var i = 0; i < columns.length; i++) {
          const key = String.fromCharCode(65 + i)
          this.excelGridData[idx][key] = columns[i]
        }
      })

      this.excelGridDom = this.excelGridData.slice(0, 40)
      this.sheetActive = this.sheetNames[index]
    },
    readWorkbook (workbook) {
      this.workbook = workbook
      this.sheetNames = workbook.SheetNames
      this.sheets = workbook.Sheets
      this.onTabWorkbook(0)
    },
    scrollEvent(e) {
      if (this.excelGridDom.length <= this.excelGridData.length) {
        const arr = this.excelGridData.slice(this.num, (this.num + 1))
        this.excelGridDom.push(...arr)
        this.num++
      }
    }
  },
  watch: {
    datas () {
      this.excelGridData = []
      this.excelGridDom = null
      const data = new Uint8Array(this.datas)
      const workbook = XLSX.read(data, { type: 'array' })
      this.readWorkbook(workbook)
    }
  }
}
</script>

<style scoped>
.excel-table {
  margin-bottom: 5px;
  height: 550px;
  overflow-y: auto;
}
table.formdata {
  border: 1px solid #ccc;
  border-collapse: collapse;
  width: 100%;
}

table.formdata th {
  border: 1px solid #ccc;
  background-color: #eee;
  color: #000000;
  text-align: left;
  font-weight: normal;
  padding: 2px 4px 2px 4px;
  margin: 0;
}

table.formdata td {
  margin: 0;
  padding: 5px;
  border: 1px solid #ccc;
  white-space: nowrap;
  word-break: keep-all;
  min-width: 100px;
}
.rowstyle {
  width: 20px;
}
</style>
